import React from "react";
import { twMerge } from "tailwind-merge";
import { IconProps } from "../../types/components";

const IconLinkedin = ({ className }: IconProps) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={twMerge("w-6 h-6", className)}
    >
      <path
        d="M7.58134 20.4669H4.26423V9.47304H7.58134V20.4669ZM5.921 7.97338C4.86052 7.97338 4 7.06917 4 5.9775C4 4.88583 4.86052 4 5.921 4C6.98148 4 7.842 4.88583 7.842 5.9775C7.842 7.06917 6.98148 7.97338 5.921 7.97338ZM19.9964 20.4669H16.6865V15.1152C16.6865 13.8397 16.6615 12.204 14.9618 12.204C13.2372 12.204 12.973 13.5898 12.973 15.0233V20.4669H9.65945V9.47304H12.8409V10.9727H12.8873C13.3301 10.1089 14.412 9.19737 16.0259 9.19737C19.3823 9.19737 20 11.4726 20 14.4278V20.4669H19.9964Z"
        fill="currentColor"
      ></path>
    </svg>
  );
};

export default IconLinkedin;
